const Welcome = () => import('~/pages/welcome').then(m => m.default || m)
const Continue = () => import('~/pages/continue').then(m => m.default || m)
const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const Register = () => import('~/pages/auth/register').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Home = () => import('~/pages/dashboard/home').then(m => m.default || m)
const Dropdowns = () => import('~/pages/dashboard/dropdowns').then(m => m.default || m)

const Application = () => import('~/pages/forms/application').then(m => m.default || m)
const Details = () => import('~/pages/forms/details').then(m => m.default || m)
const Validation = () => import('~/pages/forms/validation').then(m => m.default || m)
const ApplicationThankYou = () => import('~/pages/thank-you/application').then(m => m.default || m)
const DetailsThankYou = () => import('~/pages/thank-you/details').then(m => m.default || m)
const InvalidToken = () => import('~/pages/errors/invalid-token').then(m => m.default || m)
const InvalidApplication= () => import('~/pages/errors/invalid-application').then(m => m.default || m)

export default [
  { path: '/', name: 'welcome', component: Welcome },

  { path: '/login', name: 'login', component: Login },
  { path: '/register', name: 'register', component: Register },
  { path: '/password/reset', name: 'password.request', component: PasswordEmail },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },
  /**/
  { path: '/home', name: 'home', component: Home },
  { path: '/dropdowns', name: 'dropdowns', component: Dropdowns },
  { path: '/validation', name: 'validation', component: Validation },
  { path: '/application', name: 'application', component: Application, props: true },
  { path: '/details', name: 'details', component: Details, props: true },
  { path: '/continue', name: 'continue', component: Continue },

  { path: '/application/thank-you', name: 'application-ty', component: ApplicationThankYou, props: true },
  { path: '/details/thank-you', name: 'details-ty', component: DetailsThankYou },

  { path: '/invalid-token', name: 'invalid-token', component: InvalidToken },
  { path: '/invalid-application', name: 'invalid-application', component: InvalidApplication },

  { path: '*', component: NotFound }
]



// WEBPACK FOOTER //
// ./resources/js/router/routes.js